import { FC, ReactNode } from "react";

import { Button, ButtonProps } from "../../../general";

type IconButtonVariant = "ghost" | "submit";

interface Props {
  readonly icon: ButtonProps["icon"];
  readonly onClick: () => void;
  readonly variant?: IconButtonVariant;
  readonly label?: string;
  readonly tooltip?: ReactNode;
  readonly disabled?: boolean;
  readonly size?: ButtonProps["size"];
  readonly iconSize?: ButtonProps["iconSize"];
  readonly className?: string;
  readonly testId?: string;
}

/* The two icon-only affordances used across the chatbot: "ghost" for low-emphasis actions
   (attach, close) and "submit" for the primary send action. Wrapping the design-system Button
   keeps the appearance mapping and accessible labeling consistent across every icon control. */
const VARIANT_APPEARANCE: Record<IconButtonVariant, ButtonProps["appearance"]> = {
  ghost: "text",
  submit: "primary",
};

export const IconButton: FC<Props> = ({
  icon,
  onClick,
  variant = "ghost",
  label,
  tooltip,
  disabled = false,
  size = "small",
  iconSize,
  className,
  testId,
}) => (
  <Button
    appearance={VARIANT_APPEARANCE[variant]}
    icon={icon}
    aria-label={label}
    tooltip={tooltip}
    disabled={disabled}
    size={size}
    iconSize={iconSize}
    className={className}
    onClick={onClick}
    testId={testId}
  />
);
